import React, { useState } from "react";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../services/firebase";
import { httpsCallable, getFunctions } from "firebase/functions";
import bcrypt from "bcryptjs";
import { v4 as uuidv4 } from "uuid";
import { useSeller } from "../contexts/SellerContext";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import Logo from "../JMIlogo.png";

const Register = () => {
  const { updateSeller } = useSeller();
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpId, setOtpId] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const MOBILE_PATTERN = /^[6-9]\d{9}$/;

  const validateMobile = (number) => {
    return MOBILE_PATTERN.test(number);
  };

  const sendOtp = async () => {
    if (!validateMobile(mobile)) {
      await alert(
        "Enter a valid 10-digit Indian mobile number (starting with 6-9)",
      );
      return;
    }

    setLoading(true);
    try {
      // Check if already registered
      const q = query(collection(db, "sellers"), where("mobile", "==", mobile));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        await alert("This mobile number is already registered.");
        return;
      }

      // Trigger Cloud Function
      const functions = getFunctions();
      const sendOTP = httpsCallable(functions, "sendOTP");

      const result = await sendOTP({
        mobile,
        useCase: "REGISTRATION",
      });

      setOtpId(result.data.otpId);
      setOtpSent(true);
      await alert(`OTP sent to +91 ${mobile} successfully.`);
    } catch (err) {
      console.error("Error sending OTP:", err);
      await alert(err.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Verify OTP and Register Buyer
  const verifyOtpAndRegister = async () => {
    if (!otp || !password || !confirmPass) {
      await alert("Please fill all fields");
      return;
    }

    if (password !== confirmPass) {
      await alert("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const functions = getFunctions();
      const verifyOTP = httpsCallable(functions, "verifyOTP");

      const verifyResult = await verifyOTP({
        otpId: otpId || `+91${mobile}_JMI_REGISTRATION_OTP`,
        otp: otp.trim(),
        mobile,
        useCase: "REGISTRATION",
      });

      if (!verifyResult.data.success) {
        await alert("OTP verification failed. Please try again.");
        return;
      }

      const sellerId = "SELLER-" + uuidv4().split("-")[0].toUpperCase();
      const passwordHash = await bcrypt.hash(password, 10);

      const sellerData = {
        sellerId,
        mobile,
        createdAt: new Date(),
        passwordHash,
        status: "pending",
      };

      await setDoc(doc(db, "sellers", sellerId), sellerData);

      updateSeller({
        sellerId,
        mobile,
        registrationStatus: false,
      });

      await new Promise((resolve) => setTimeout(resolve, 100));
      await alert(
        "Account created successfully! ✓ Now, let’s set up your business",
      );
      nav("/sellerregistration", { replace: true });
    } catch (err) {
      console.error("Registration error:", err);
      if (err.message.includes("expired")) {
        await alert("OTP has expired. Please request a new one.");
        setOtpSent(false);
      } else if (err.message.includes("Invalid")) {
        await alert("Invalid OTP. Please check and try again.");
      } else {
        await alert(
          err.message ||
            "Something went wrong during verification. Please try again.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="title">
        <img src={Logo} alt="" className="logo" srcset="" />
      </h1>
      <p className="subtitle">Seller Desk</p>

      <div className="login-box">
        <h2>Registration</h2>

        <label>Seller Mobile</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
          disabled={otpSent}
          inputMode="numeric"
          pattern="\d{10}"
          title="Please enter a valid 10-digit mobile number"
        />

        {!otpSent ? (
          <button className="login-btn" onClick={sendOtp} disabled={loading}>
            {loading ? "Generating OTP..." : "Send OTP"}
          </button>
        ) : (
          <>
            <label>OTP</label>
            <input
              type="number"
              placeholder="Enter OTP (sent via WhatsApp)"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <label>Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />

            <button
              className="login-btn"
              onClick={verifyOtpAndRegister}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Register"}
            </button>
          </>
        )}
      </div>

      <p className="register-link">
        Already have an account?{" "}
        <span onClick={() => nav("/login")}>Login</span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        <span
          onClick={() => window.open("https://wa.me/919053999090", "_blank")}
        >
          {" "}
          Need help?{" "}
        </span>
        Contact Seller Support
      </p>

      {/* Hidden container (in case you keep reCAPTCHA for other flows) */}
      <div id="recaptcha-container"></div>
    </div>
  );
};

export default Register;
